<template>
  <div class="preguide-play-container">
    <div class="player-wrapper" ref="playerWrap" :style="getCoverStyle">
      <div class="stop-placeholder prism-player" v-show="placeholderCoverShow" :style="getCoverStyle">
        <div class="big-play-btn" @click.prevent.stop="onClickPlay"></div>
      </div>
      <div
        class="video-wrapper"
        :class="
          [
            userActionActive ? 'user-active': 'user-inactive',
            { 'has-started': hasStarted },
            { 'playing': !playPaused },
            { 'ended': hasEnded }
          ]
        "
        :style="getCoverStyle"
      >
        <video
          width="100%"
          height="100%"
          class="try-see-video"
          oncontextmenu="return false;"
          x5-video-player-type="h5-page"
          x5-video-player-fullscreen="true"
          webkit-playsinline="true"
          playsinline="true"
          preload="metadata"
          :src="videoUrl"
          :poster="poster"
          @click.prevent.stop="togglePlay1"
          @play="onVideoPlay"
          @playing="onVideoPlaying"
          @pause="onVideoPuse"
          @canplay="onVideoCanplay"
          @ended="onVideoEnded"
          @loadeddata="loadeddata"
          @loadedmetadata="loadedmetadata"
          id="preguide-video"
          ref="player"
        >
        </video>
        <div class="ctrl-func-bar">
          <div class="main-box">
            <!-- 播放/暂停 -->
            <div
              @click.stop="togglePlay"
              class="play-control"
              :class="[ playPaused ? 'on-pause': 'on-play' ]"
            >
            </div>
            <!-- 当前 -->
            <div class="current-time">{{ videoCurrentTime | playTimeStr }}</div>
            <!-- 进度条 -->
            <div class="process-control">
              <van-slider
                v-model="processSliderValue"
                active-color="#ff9645"
                :min="0"
                :max="100"
                @input="onProcessValueChange"
              >
                <template #button>
                  <div class="custom-button"></div>
                </template>
              </van-slider>
            </div>
            <!-- 时长 -->
            <div class="max-time">{{ videoDuration | playTimeStr }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Slider } from 'vant';
import { addClass, removeClass } from '@/common/js/dom';

export default {
  name: 'promote-player',
  components: {
    [Slider.name]: Slider
  },
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    videoUrl: {
      type: String,
      default: '',
    },
    coverImageUrl: {
      type: String,
      default: '',
    },
    pauseIt: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    playTimeStr(remainPlayTime) {
      const minutes = Math.max(Math.floor(remainPlayTime / 60), 0);
      // eslint-disable-next-line no-nested-ternary
      const seconds = remainPlayTime % 60 >= 10 ? Math.floor(remainPlayTime % 60) : remainPlayTime % 60 > 0 ? `0${Math.floor(remainPlayTime % 60)}` : '00';
      return `${minutes}:${seconds}`;
    }
  },
  computed: {
    getCoverStyle() {
      return `width: ${this.width}; height: ${this.height};`;
    },
    player() {
      return this.$refs.player;
    },
  },
  watch: {
    pauseIt: {
      handler(val) {
        if (val === true) {
          this.pause();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      placeholderCoverShow: true,
      playerPauseHide: false,
      videoDuration: 0,
      processSliderValue: 0,
      videoCurrentTime: 0,
      currentTimeTimer: null,
      playPaused: true,
      userActionActive: false,
      hasStarted: false,
      hasEnded: false,
      poster: ''
    };
  },
  mounted() {
    if (!this.videoUrl) {
      return;
    }
    const idx = this.videoUrl.lastIndexOf('.') + 1;
    const type = this.videoUrl.substr(idx);

    if (type === 'mp4') {
      // 阿里云：获取视频关键帧
      this.poster = `${this.videoUrl}?x-oss-process=video/snapshot,t_3000,f_jpg,w_320,h_180`;
    } else {
      this.poster = '';
    }
  },
  methods: {
    play() {
      this.player.play();
    },
    pause() {
      this.player.pause();
    },
    togglePlay() {
      this.userActionActive = !this.userActionActive;
      const isPause = this.player.paused;
      isPause || this.playPaused ? this.play() : this.pause();
    },
    togglePlay1() {
      this.userActionActive = !this.userActionActive;
      if (this.userActionActive) {
        setTimeout(() => {
          this.userActionActive = false;
        }, 3000);
      }
    },
    onClickPlay() {
      this.$emit('playClick');
      this.play();
    },
    onVideoPlay() {
      const videosDom = document.getElementsByTagName('video');
      const videos = Array.from(videosDom);
      videos.forEach((video) => {
        if (video !== this.player) {
          video.pause();
        }
      });
    },
    onVideoPlaying() {
      this.placeholderCoverShow = false;
      this.playerPauseHide = false;
      this.playPaused = false;
      this.hasStarted = true;
      this.hasEnded = false;

      // this.videoPlayState = 'playing';
      this.currentTimeTimer = setInterval(() => {
        this.videoCurrentTime = this.player.currentTime;
        this.processSliderValue = this.videoCurrentTime * 100 / this.videoDuration;
      }, 1000);
    },
    onVideoPuse() {
      // this.placeholderCoverShow = true;
      this.playerPauseHide = true;
      this.playPaused = true;

      if (this.currentTimeTimer) {
        clearInterval(this.currentTimeTimer);
      }
    },
    onVideoCanplay() {
    },
    onVideoEnded() {
      const bigBtn = this.$refs.playerWrap.getElementsByClassName('big-play-btn')[0];
      addClass(bigBtn, 'replay');
      this.player.src = this.videoUrl;
      this.player.currentTime = 0;
      this.videoCurrentTime = 0;
      this.placeholderCoverShow = true;
      this.playPaused = true;
      this.hasEnded = true;
    },
    loadedmetadata(e) {
      this.videoDuration = e.target.duration;
    },
    // event
    loadeddata() {
      // const captureImage = () => {
      //   const scale = 1;
      //   const video = document.getElementById('preguide-video');
      //   video.setAttribute('crossOrigin', 'anonymous');
      //   const canvas = document.createElement('canvas');
      //   canvas.width = video.clientWidth * scale;
      //   canvas.height = video.clientHeight * scale;
      //   canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      //   const dataURL = canvas.toDataURL('image/png');
      //   console.log(dataURL);
      //   this.posterUrl = dataURL;
      // };
      // captureImage();
    },
    resetVideoClassName() {
      const bigBtn = this.$refs.playerWrap.getElementsByClassName('big-play-btn')[0];
      removeClass(bigBtn, 'replay');
    },
    onProcessValueChange(value) {
      this.processSliderValue = value;
      this.videoCurrentTime = Math.min(this.videoDuration * value / 100, this.videoDuration);
      this.player.currentTime = this.videoCurrentTime;
    },

  },
};
</script>

<style scoped lang="stylus">
  @import "./../../common/stylus/variable.styl"
  .preguide-play-container {
    position relative
    width 100%
    padding-bottom 55.977%
    .poster-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99;
      margin: auto;
      .img {
        display block
        height: 100%;
        margin auto;
      }
    }
  }
  .player-wrapper {
    position: absolute;
    top 0
    left 0
    width 100%
    // background-color: #000
    // background-color: #fff
    .video-wrapper {
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      video {
        object-fit contain
      }
      .ctrl-func-bar {
        display: none;
        position absolute
        left 0
        bottom 0
        width 100%
        height: 100px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
        visibility: visible;
        opacity: 0;
        transition: visibility .1s,opacity .1s
        .main-box {
          position absolute
          left 0
          bottom 0
          display flex
          align-items center
          // justify-content center
          width 100%
          height 56px
          .play-control {
            width 46px
            height 56px
            &.on-pause {
              background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABpUExURUxpcf///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////6RiatkAAAAidFJOUwD+qFIF3Iv378M6C+XTzFoXmW+5Ai4SNSdLZLIgaXlBoYB5anCQAAABZElEQVR42u2Y2W6DMBBFbTBeWMISIAmEkNz//8hKVauKBvCSeeR8wBEz+HoG2MHBD1nclBWB55YD4Oeh/9BzUQDw7YrFJ6IIf2h5DRdpLDClCOw0/pM/grpV4R1VB1R4xRo86nxFKTYYU89ThE3M7CMqsYPxeKoJu5wvrqIHLIyObZewwaO7i6iGHSV7t6jZ0Y01OGe4kcQWkYErZv8FnuAMr3saEaCndlNUwIvT5llP4Ad/VjQiQA+rohz+mCuRCOohLHe/M8WFSAQu26VIIRS5FHGEoqlEiqq0mqbZeAoSUXIjOZBcZjQR6WhCO9GkP6pILrZiprlqG8EoRM+KZBwVKcmAzKeWYmQrmTksETT7iHSZ1SSLVhEzJxpLysuWYhnNB0GxHieNoFjYT4ui7HRYg48z8+RO9VGTvUf8VbEQ1LImM1jC4JTa5HVnwXT8t6Q6ZR9x0wDUGAuKHwhxzw4OvPkC0nUNqb0u6egAAAAASUVORK5CYII=') center left 12px no-repeat
              background-size 24px
            }
            &.on-play {
              background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMABojuA/bHFAAAADpJREFUOMtjYBi0gFHZxUgAgwkETC4uLgoYTCBgBvIMMJhAwALkOWAwRyVGJUYl8GYcnFkNZ+akMQAA7olOXc2omsgAAAAASUVORK5CYII=') center left 12px no-repeat
              background-size 24px
            }
          }
          .current-time {
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            // transform scale(0.5)
            // transform-origin 100% 100%
          }
          .process-control {
            flex 1
            padding 0 8px
            .custom-button {
              display inline-flex
              align-items center
              justify-content center
              width: 18px;
              height: 18px;
              background-color: rgba(255, 150, 69, 0.36);
              border-radius: 100%;
              &::before {
                content ''
                display inline-block
                width: 10px;
                height: 10px;
                background-color: rgba(255, 150, 69, 1);
                border-radius: 100%;
              }
            }
          }
          .max-time {
            padding-right 12px
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            // transform scale(0.5)
            // transform-origin 100% 100%
          }
        }
      }
      &.has-started {
        .ctrl-func-bar {
          display: flex;
          visibility: visible;
          opacity: 1;
          transition: visibility .1s,opacity .1s
        }
        &.user-inactive {
          .ctrl-func-bar {
            display flex
            visibility: visible;
            opacity: 1;
            transition: visibility 1s,opacity 1s
          }
          &.playing {
            .ctrl-func-bar {
              display none
              visibility: visible;
              opacity: 0;
              transition: visibility 1s,opacity 1s
            }
          }
        }
        &.ended {
          .ctrl-func-bar {
            display none
          }
        }
      }

    }
    .stop-placeholder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 100
      margin: auto;
      .placeholder-cover {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .big-play-btn {
        position: absolute
        top: 50%
        left: 50%
        transform translate(-50%, -50%)
        width: 48px
        height: 48px
        display: block
        background: url(./com_icon_cover_play.png) center center no-repeat;
        background-size: contain;
        &.replay {
          // background: url(./com_icon_cover_replay.png) center center no-repeat;
          background: url(./com_icon_cover_play.png) center center no-repeat;
          background-size: contain;
        }
      }
    }
  }

.try-see-video {
  width 100%
  height 100%
  border-radius 4px
}

</style>
